var _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoccerJersey1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    :root{ --c1:#FFD05B; --c2:#98DB7C; --c3:#7AD7EE; }\n  ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--c1)"
    },
    d: "M469.119,184.964l-22.71-102.196c-3.735-16.808-16.171-30.338-32.605-35.474L312.113,15.516 H199.887L98.196,47.294C81.762,52.43,69.326,65.96,65.591,82.768l-22.71,102.196c-1.856,8.354,3.176,16.694,11.432,18.945 l73.429,20.026v248.5h256.516v-248.5l73.429-20.026C465.943,201.658,470.976,193.318,469.119,184.964z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--c2)"
    },
    d: "M127.742,272.032L336.161,63.613l10.644-37.255l49.698,15.53l-84.391-26.372H199.887L98.196,47.294 C81.762,52.43,69.326,65.96,65.591,82.768l-22.71,102.196c-1.856,8.354,3.176,16.694,11.432,18.945l73.429,20.026V272.032z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--c3)"
    },
    points: "384.258,472.435 384.258,223.935 135.758,472.435 \t\t"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--c2)"
    },
    d: "M312.113,15.516H199.887l-53.304,16.658c11.254,50.095,55.925,87.552,109.417,87.552 s98.163-37.457,109.417-87.552L312.113,15.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--c2)"
    },
    d: "M193.872,7.5c-10.146,0-18.135,9.394-15.708,19.245c8.619,34.977,40.198,60.916,77.836,60.916 s69.217-25.939,77.836-60.916c2.427-9.851-5.562-19.245-15.708-19.245H193.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--c1)"
    },
    d: "M384.258,223.935l73.429-20.026c8.256-2.252,13.288-10.591,11.432-18.945l-3.698-16.643 l-81.163,22.135V223.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--c2)"
    },
    d: "M127.742,223.935l-73.429-20.026c-8.256-2.252-13.288-10.591-11.432-18.945l3.698-16.643 l81.163,22.135V223.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--c2)"
    },
    d: "M310.362,7.5H201.638c-0.598,0-1.161,0.127-1.74,0.199c0.109,30.898,25.18,55.913,56.103,55.913 s55.993-25.016,56.103-55.913C311.523,7.627,310.961,7.5,310.362,7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "var(--c3)"
    },
    d: "M368.226,504.5H143.774c-8.854,0-16.032-7.178-16.032-16.032v-16.032h256.516v16.032 C384.258,497.322,377.08,504.5,368.226,504.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--c1)"
    },
    points: "336.161,207.903 312.113,223.935 288.065,207.903 288.065,167.823 336.161,167.823 \t\t"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "var(--c1)"
    },
    points: "312.113,223.935 336.161,207.903 336.161,167.823 312.113,167.823 \t\t"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M193.872,7.5c-10.146,0-18.135,9.394-15.708,19.245c8.619,34.977,40.198,60.916,77.836,60.916s69.217-25.939,77.836-60.916 c2.427-9.851-5.562-19.245-15.708-19.245H193.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M127.742,223.935l-73.429-20.026c-8.256-2.252-13.289-10.591-11.432-18.945L65.56,82.906c3.752-16.882,16.278-30.45,32.807-35.536 l77.472-23.837"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 127.742,
    y1: 190.456,
    x2: 48.287,
    y2: 168.787
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M432.355,63.613l-43.019,86.038c-3.339,6.678-5.078,14.043-5.078,21.51v317.307c0,8.854-7.178,16.032-16.032,16.032H143.774 c-8.854,0-16.032-7.178-16.032-16.032V171.161c0-7.467-1.738-14.831-5.078-21.51L79.645,63.613"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M384.258,223.935l73.429-20.026c8.256-2.252,13.289-10.591,11.432-18.945L446.44,82.906c-3.752-16.882-16.278-30.45-32.807-35.536 l-77.471-23.837"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 384.258,
    y1: 190.456,
    x2: 463.713,
    y2: 168.787
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 352.194,
    y1: 472.435,
    x2: 384.258,
    y2: 472.435
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 127.742,
    y1: 472.435,
    x2: 320.129,
    y2: 472.435
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M199.887,104.776c16.614,9.567,35.829,14.95,56.113,14.95c51.784,0,96.593-35.078,108.969-85.312 M147.031,34.417 c4.952,20.099,15.097,37.772,28.804,51.742"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 135.758,
    y1: 472.435,
    x2: 384.258,
    y2: 223.935
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 127.742,
    y1: 272.032,
    x2: 282.693,
    y2: 117.081
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 336.161,207.903 312.113,223.935 288.065,207.903 288.065,167.823 336.161,167.823 \t\t"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccerJersey1);
export default __webpack_public_path__ + "static/media/soccer-jersey-1.c3bd9e7cd09586f524983ae1513ccab9.svg";
export { ForwardRef as ReactComponent };